import React from 'react';
import { motion } from 'framer-motion';
import './BettingItemCard.css';

const BettingItemCard = ({ item, onClick, index = 0 }) => {
  return (
    <motion.div
      className="betting-item-card"
      onClick={() => onClick(item)}
      initial={{ opacity: 0, y: 40, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ 
        duration: 0.5, 
        delay: index * 0.1,
        ease: [0.19, 1, 0.22, 1]
      }}
      whileHover={{ 
        y: -8,
        transition: { duration: 0.2 }
      }}
      whileTap={{ scale: 0.98 }}
    >
      <div className="card-glow" />
      
      <div className="card-content">
        <motion.div 
          className="card-icon"
          whileHover={{ 
            scale: 1.1,
            rotate: [0, -5, 5, 0],
            transition: { duration: 0.5 }
          }}
        >
          {item.image}
        </motion.div>
        
        <div className="card-info">
          <h3 className="card-title">{item.name}</h3>
          <p className="card-description">{item.description}</p>
          
          <div className="card-prizes">
            <div className="prize-range">
              <span className="prize-label">Win up to</span>
              <span className="prize-value">{item.maxPrize}</span>
            </div>
          </div>
        </div>
        
        <div className="card-footer">
          <div className="card-cost">
            <span className="cost-label">Entry</span>
            <span className="cost-value">KES {item.cost}</span>
          </div>
          
          <motion.button 
            className="play-button"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span>Play Now</span>
            <span className="play-icon">→</span>
          </motion.button>
        </div>
      </div>
      
      <div className="card-shine" />
    </motion.div>
  );
};

export default BettingItemCard;

